exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-content[data-v-0eccd78d]{max-height:100%}.modal-content .modal-body[data-v-0eccd78d]{max-height:100%;min-height:100%;overflow:auto}.modal-content .modal-body .content[data-v-0eccd78d]{min-height:100%;overflow-y:auto}.modal-content .modal-body .content .obsolete[data-v-0eccd78d]{text-decoration:line-through}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0eccd78d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./scss/mbstalas/_wp_variables.scss","./node_modules/bootstrap/scss/_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/dialogs/modalVariant.vue
// module id = 1298
// module chunks = 146